import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { auditUrls } from "./auditUtils";
import { apiUrls } from "../../library/Utils";
import { prepareGridData, prepareCAGridData } from "./auditUtils";
import { useLocation } from "react-router-dom";
import { saveAs } from "file-saver";

export const GetUserCountries = createAsyncThunk(
  "audit/GetUserCountries",
  async (obj) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + data.userID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const getScenariosForCountry = createAsyncThunk(
  "audit/getScenariosForCountry",
  async ({ countryID }, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = auditUrls.getScenariosForCountry +
      `?countryId=${countryID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error in audit/getScenariosForCountry : ", error);
    }
  }
);

export const getPeriods = createAsyncThunk(
  "audit/getPeriods",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = auditUrls.getPeriods;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarioAuditReport = createAsyncThunk(
  "audit/getScenarioAuditReport",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = auditUrls.getScenarioAuditReport +
      `?scenarioId=${obj.scenarioID}&period=${obj.period}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error in audit/getScenariosForCountry : ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "define/downloadfile",
  async (filepath, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = auditUrls.downloadFile + `?fileName=${filepath}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const res = await response.blob();
      const fileName = filepath;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCommentsAndAttachments = createAsyncThunk(
  "audit/getCommentsAndAttachments",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = auditUrls.getCommentsAndAttachments +
      `?scenarioId=${obj.scenarioID}&period=${obj.period}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error in audit/getCommentsAndAttachments : ", error);
    }
  }
);

export const ExportAuditData = createAsyncThunk(

  "audit/ExportAuditData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      auditUrls.exportData;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj), // Sending the entire obj directly
      });

      const res = await response.blob();
      console.log("The result after download", res);
      const extension = obj.isPdf ? "pdf" : "xlsx";
      const location = window.location.pathname;
      let fileName = "";

      if (location.endsWith("/Modifications_Scenario")) {
        fileName = `ScenarioModificationReport_${obj.selectedScenarioName}_${obj.selectedCountry}.${extension}`;
      } else if (location.endsWith("/Comments_Attachments")) {
        fileName = `CommentsAndAttachmentsReport_${obj.selectedScenarioName}_${obj.selectedCountry}.${extension}`;
      }
      saveAs(res, fileName);
      return res;


    } catch (error) {
      console.error("Error: ", error);
    }
  }
);




const initialState = {
  isLoading: false,
  isSuccess: false,
  isSuccess_Info: "",
  isFailed: false,
  isFailed_Info: "",
  isError: false,
  isAlert: false,
  isAlert_Info: "",
  countries: [],
  selectedCountry: "",
  selectedCountryID: "",
  scenarios: [],
  periods: [],
  selectedScenarioName: "",
  selectedScenarioID: "",
  selectedPeriod: "",
  showScenarioAuditData: false,
  scenarioAuditReports: [],
  auditSKUCustomerLogs: [],
  showOrHideExport: false,
  showCommentsAndAttachments: false,
  commentsAndAttachmentsData: [],
}
const auditSlice = createSlice({
  name: "audit",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetUserCountries.pending, (state, action) => {
      state.isLoading = true;
    }).
      addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        state.countries = payload;
        state.isLoading = false;
      }).addCase(GetUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from GetUserCountries", action.error.message)
      })
      .addCase(getScenariosForCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosForCountry.fulfilled, (state, action) => {
        state.scenarios = action.payload;
        //console.log("The result of getScenariosForCountry",action.payload);
        state.isLoading = false;
      })
      .addCase(getScenariosForCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenariosForCountry", action.error.message);
      })
      .addCase(getPeriods.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPeriods.fulfilled, (state, action) => {
        state.periods = action.payload;
        state.isLoading = false;
      })
      .addCase(getPeriods.rejected, (state, action) => {
        console.error("Error from getPeriods", action.error.message);
        state.isLoading = false;
      })
      .addCase(getScenarioAuditReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioAuditReport.fulfilled, (state, action) => {
        //state.periods = action.payload;
        //console.log("The getScenarioAuditReport result is",action.payload);
        //console.log("The audit reports are",action.payload.auditReports);
        state.scenarioAuditReports = prepareGridData(action.payload.auditReports);
        if (action.payload && action.payload.auditReports && action.payload.auditReports.length > 0) {
          state.showOrHideExport = true;
        }
        else {
          state.showOrHideExport = false;
        }
        //state.scenarioAuditReports=action.payload.auditReports;
        state.auditSKUCustomerLogs = action.payload.auditSKUCustomerLogs;
        state.isLoading = false;
      })
      .addCase(getScenarioAuditReport.rejected, (state, action) => {
        console.error("Error from getScenarioAuditReport", action.error.message);
        state.isLoading = false;
      })

      .addCase(getCommentsAndAttachments.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCommentsAndAttachments.fulfilled, (state, action) => {
        state.commentsAndAttachmentsData = prepareCAGridData(action.payload);
        if (action.payload && action.payload.length > 0) {
          state.showOrHideExport = true;
        }
        else {
          state.showOrHideExport = false;
        }
        state.isLoading = false;
      })
      .addCase(getCommentsAndAttachments.rejected, (state, action) => {
        console.error("Error from getCommentsAndAttachments", action.error.message);
        state.isLoading = false;
      })
      .addCase(ExportAuditData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportAuditData.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(ExportAuditData.rejected, (state, action) => {
        console.error("Error from ExportAuditData", action.error.message);
        state.isLoading = false;
      })
      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        console.error("quota/DownloadFile", action.error.message);
        state.isLoading = false;
      });
  }
});

export const {
  setState
} = auditSlice.actions;

export default auditSlice.reducer;